import React, { useContext } from 'react'
import { TextContext } from 'hocs'
import { DataTable, DataTd, ContactPerson } from 'components/atoms'
import * as Styled from './FacilityInformation.styles'
import { arrayOf, shape, string } from 'prop-types'

const FacilityInformation = ({ contactData, infoData }) => {
  const textContext = useContext(TextContext)

  return (
    <Styled.FacilityInformation>
      {contactData.length > 0 && (
        <div className='contact-persons'>
          <p data-cy='contact-persons-title'>
            <b>{textContext['facilityInformation.headline.contactPersons']}</b>
          </p>
          {contactData.map((item, index) => (
            <ContactPerson key={ index } contactPerson={ item } />
          ))}
        </div>
      )}
      <div className='facility-facts'>
        <p data-cy={ 'facility-information-headline-facts' }>
          <b>{textContext['facilityInformation.headline.facts']}</b>
        </p>
      </div>
      <DataTable className='facility-data'>
        <tbody>
          <tr>
            <DataTd>
              {textContext['facilityInformation.label.totalPlaces']}
            </DataTd>
            <DataTd className='facility-value-col'>
              {infoData.totalPlaces}
            </DataTd>
          </tr>
          {infoData.shortTermPlaces && (
            <tr>
              <DataTd>
                <span className={ 'icon-arrow' }>&#8618; </span>
                {textContext['facilityInformation.label.shortTermPlaces']}
              </DataTd>
              <DataTd>{infoData.shortTermPlaces}</DataTd>
            </tr>
          )}
          {infoData.singleBedroomPlaces && (
            <tr>
              <DataTd>
                <span className={ 'icon-arrow' }>&#8618; </span>
                {textContext['facilityInformation.label.singleBedroomPlaces']}
              </DataTd>
              <DataTd>{infoData.singleBedroomPlaces}</DataTd>
            </tr>
          )}
          {infoData.doubleBedroomPlaces && (
            <tr>
              <DataTd>
                <span className={ 'icon-arrow' }>&#8618; </span>
                {textContext['facilityInformation.label.doubleBedroomPlaces']}
              </DataTd>
              <DataTd>{infoData.doubleBedroomPlaces}</DataTd>
            </tr>
          )}
        </tbody>
      </DataTable>
    </Styled.FacilityInformation>
  )
}

FacilityInformation.propTypes = {
  contactData: arrayOf(
    shape({
      name: string,
      phone: string,
      email: string,
    })
  ).isRequired,
  infoData: shape({
    totalPlaces: string.isRequired,
    shortTermPlaces: string,
    singleBedroomPlaces: string,
    doubleBedroomPlaces: string,
  }).isRequired,
}

export default FacilityInformation
